<template>
  <div class="page-section">
    <div class="modal-overlay" v-if="isHelpDialogOpen">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ℹ️ Bantuan & Informasi</h5>
          </div>
          <div class="modal-body">
            <p>Cashless: layanan ini digunakan apabila kartu peserta atau e-card dapat diproses oleh rumah sakit. Peserta
              cukup menunjukkan kartu, dan biaya sesuai manfaat akan diproses tanpa pembayaran di awal.</p>
            <p>Cashless Standby: layanan ini digunakan apabila kartu peserta atau e-card tidak dapat diproses di rumah sakit.
              Peserta tetap dapat menerima perawatan tanpa membayar di awal dengan melakukan verifikasi manual
              melalui WhatsApp Salvus di 0851-7988-6909.</p>
          </div>
          <div class="modal-footer">
            <button @click="closeHelpDialog" class="btn btn-primary">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="search-bar-wrapper my-3">
        <form @submit.prevent="onSearch" class="search-form">
          <input type="text" class="form-control rekanan-search" placeholder="Cari rekanan" v-model="keyword">
        </form>
        <div @click="openHelpDialog" class="help-icon-link-inline">
          <img src="@/assets/img/ic_help.png" alt="Bantuan">
        </div>
      </div>

      <div v-for="item in items" :key="item._id">
        <div class="text-subheading text-color-blue text-uppercase">{{ item.name }} ({{item.partnership}})</div>
        <div class="text-description text-uppercase my-2">{{ item.address_complete }} </div>
        <div class="text-description text-uppercase">{{ item.phone1 }}</div>
        <div class="rekanan-more mt-2">
          <button @click="getContact(item.phone1)" class="text-color-blue text-note p-2 bg-transparent border-0">
            <div><i class="fas fa-phone-alt mr-1 text-color-green"></i>Telepon Sekarang</div>
          </button>
        </div>
        <input type="text" class="text-right" v-model="item.phone1"
               style="display:contents;bottom:0%;z-index:-99999;height:0px;border:none;color:transparent;">
        <input id="copyTextContact" type="text" class="text-right" v-model="setPhone"
               style="display:contents;bottom:0%;z-index:-99999;height:0px;border:none;color:transparent;">
        <hr>
      </div>
      <b-pagination
          pills align="center"
          v-model="currentPage"
          :total-rows="totalPage"
          per-page="10"
          @change="pageClick"/>
    </div>
    <b-modal id="attention" ref="attention"
             hide-header hide-footer centered>
      <div class="text-center text-description text-color-blue m-4">
        Detail kontak berhasil di copy ke clipboard.
      </div>
      <b-button class="color-blue mt-3" block @click="hasCopy">Oke</b-button>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: '',
      setPhone: '',
      currentPage: 1,
      isHelpDialogOpen: true
    }
  },
  props: {
    items: Array,
    totalPage: Number,
  },
  methods: {
    openHelpDialog() {
      this.isHelpDialogOpen = true;
    },
    closeHelpDialog() {
      this.isHelpDialogOpen = false;
    },
    onSearch() {
      this.$eventBus.$emit('provider_search', this.keyword)
    },
    pageClick(nowPage) {
      this.$eventBus.$emit("pagination", nowPage);
    },
    getContact(getPhone) {
      this.setPhone = getPhone
      this.copyContact()
    },
    copyContact() {
      var copyText = document.getElementById("copyTextContact");
      copyText.select();
      copyText.setSelectionRange(0, 99999)

      navigator.clipboard.writeText(copyText.value);
      this.$refs.attention.show()
    },
    hasCopy() {
      var hasCopyText = document.getElementById("copyTextContact");
      hasCopyText.select();
      hasCopyText.setSelectionRange(0, 99999)

      navigator.clipboard.writeText(hasCopyText.value);
      this.$refs.attention.hide()
    }
  }
}
</script>

<style>


.search-bar-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}


.search-bar-wrapper .search-form {
  flex-grow: 1
}

.help-icon-link-inline {
  cursor: pointer;
}

.help-icon-link-inline img {
  width: 34px;
  height: 34px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-dialog {
  max-width: 400px;
  width: 90%;
  margin: 1.75rem;
}

.modal-content {
  background-color: #fff;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  padding: 15px;
}

.modal-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
}

.modal-body p {
  margin-bottom: 10px;
}

.modal-footer {
  padding-top: 10px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 8px 15px;
  border-radius: 0.25rem;
  cursor: pointer;
}

</style>